import { Col, Form, Row } from 'antd';
import OsForm from './OsForm';
import FinancialForm from './FinancialForm';
import { OsXFinancialFilterDateBy } from '@/core/domain/questReport/Reports/OsXFinancial/OsXFinancial.types';

const OverviewForm = () => {
  return (
    <Row gutter={[24, 24]}>
      <Col>
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const filterByDate = getFieldValue('filterDateBy');

            return (
              <>
                {filterByDate === OsXFinancialFilterDateBy.os ? (
                  <OsForm />
                ) : (
                  <FinancialForm />
                )}
              </>
            );
          }}
        </Form.Item>
      </Col>
    </Row>
  );
};

export default OverviewForm;
